import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleDiscount, changeSingleDiscountStatus, deleteSingleDiscount, viewSingleDiscount,discountList, discountUsageList, updateSingleDiscount} from "../apis/apiHandler";

export const discount = createAsyncThunk(
    "discount/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await discountList(payload);

            if (response?.code === 1 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addDiscount = createAsyncThunk(
    "discount/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            console.log("addDiscount payload",payload);
            const response = await addSingleDiscount(payload);

            if (response?.code === 1) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateDiscount = createAsyncThunk(
    "discount/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleDiscount(payload);

            if (response?.code === 1) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteDiscount = createAsyncThunk(
    "discount/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleDiscount(payload);

            if (response?.code === 1) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeDiscountStatus = createAsyncThunk(
    "discount/changeStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeSingleDiscountStatus(payload);

            if (response?.code === 1) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const discountUsage = createAsyncThunk(
    "discount/usage",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await discountUsageList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);
export const discountView = createAsyncThunk(
    "discount/view",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewSingleDiscount(payload);

            if (response?.code === 1 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    discountList: [],
    addDiscountData: {},
    updateDiscountData: {},
    deleteDiscountData: {},
    discountDetailData:{},
    changeDiscountStatusData: {},
    discountUsages:[],
    error: null,
    success: false,
};

const discountSlice = createSlice({
    name: "discount",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(discount.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(discount.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.discountList = payload;
                state.success = true;
            })
            .addCase(discount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })

            .addCase(discountView.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(discountView.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.discountDetailData = payload;
                state.success = true;
            })
            .addCase(discountView.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            
            .addCase(addDiscount.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addDiscount.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addDiscountData = payload;
                state.success = true;
            })
            .addCase(addDiscount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateDiscount.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateDiscount.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateDiscountData = payload;
                state.success = true;
            })
            .addCase(updateDiscount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteDiscount.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteDiscount.fulfilled, (state, { payload }) => {
                console.log();
                state.loading = false;
                state.deleteDiscountData = payload;
                state.success = true;
            })
            .addCase(deleteDiscount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeDiscountStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeDiscountStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeDiscountStatusData = payload;
                state.success = true;
            })
            .addCase(changeDiscountStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(discountUsage.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(discountUsage.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.discountUsages = payload;
                state.success = true;
            })
            .addCase(discountUsage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default discountSlice.reducer;
